import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { brandPush } from "../../../helpers/brandNavigation";
import { getBrandPrefix } from "../../../helpers/restaurantSlugDetector";
import Ink from "react-ink";
import "./styles.css";

class BrandRestaurantSelector extends Component {
    state = {
        showModal: false,
        restaurants: [],
        selectedRestaurant: null,
    };

    componentDidMount() {
        // Initialize restaurants from props
        if (this.props.restaurants) {
            this.setState({ restaurants: this.props.restaurants });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.restaurants !== prevProps.restaurants) {
            this.setState({ restaurants: this.props.restaurants || [] });
        }
    }

    openModal = () => {
        this.setState({ showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    selectRestaurant = (restaurant) => {
        this.setState({ selectedRestaurant: restaurant, showModal: false });
        
        // Notify parent component
        if (this.props.onRestaurantSelect) {
            this.props.onRestaurantSelect(restaurant);
        }
    };

    render() {
        const { currentRestaurant } = this.props;
        const { showModal } = this.state;
        
        // Use props directly instead of state for restaurants
        // Ensure restaurants is always an array
        const restaurants = Array.isArray(this.props.restaurants) ? this.props.restaurants : [];
        console.log('🏪 BrandRestaurantSelector - restaurants:', restaurants.length, restaurants);

        const getDistanceValue = (restaurant) => {
            if (
                restaurant &&
                restaurant.distance !== null &&
                restaurant.distance !== undefined &&
                !isNaN(parseFloat(restaurant.distance))
            ) {
                return parseFloat(restaurant.distance);
            }
            return Number.POSITIVE_INFINITY;
        };

        const sortedRestaurants = [...restaurants].sort(
            (a, b) => getDistanceValue(a) - getDistanceValue(b)
        );

        return (
            <React.Fragment>
                {/* Trigger Button */}
                <div className="brand-location-trigger">
                    <i className="icon-location3"></i>
                    <button 
                        className="btn brand-location-button" 
                        onClick={this.openModal}
                    >
                        {currentRestaurant ? currentRestaurant.address : 'Select Location'}
                        <i className="ri-arrow-down-s-fill"></i>
                    </button>
                </div>

                {/* Modal with Restaurant List */}
                {showModal && (
                    <div className="brand-restaurant-selector-modal">
                        <div className="brand-restaurant-selector-overlay" onClick={this.closeModal}></div>
                        <div className="brand-restaurant-selector-content">
                            <div className="brand-restaurant-selector-header">
                                <h5 className="brand-restaurant-selector-title">
                                    <i className="icon-location3 mr-2"></i>
                                    Select Store Location
                                </h5>
                                <button 
                                    type="button" 
                                    className="brand-restaurant-selector-close" 
                                    onClick={this.closeModal}
                                >
                                    <i className="icon-cross2"></i>
                                </button>
                            </div>
                            <div className="brand-restaurant-selector-body">
                                <div className="brand-restaurant-list">
                                    {sortedRestaurants && sortedRestaurants.length > 0 ? (
                                        sortedRestaurants.map((restaurant) => (
                                            <div 
                                                key={restaurant.id}
                                                className={`brand-restaurant-item ${currentRestaurant && currentRestaurant.id === restaurant.id ? 'active' : ''}`}
                                                onClick={() => this.selectRestaurant(restaurant)}
                                            >
                                                <div className="brand-restaurant-info">
                                                    <div className="brand-restaurant-name-row">
                                                        <div className="brand-restaurant-name">
                                                            {restaurant.name}
                                                        </div>
                                                        {currentRestaurant && currentRestaurant.id === restaurant.id && (
                                                            <span className="brand-restaurant-current-badge">✓ Current</span>
                                                        )}
                                                    </div>
                                                    <div className="brand-restaurant-address">
                                                        <i className="icon-location4 mr-2"></i>
                                                        <span>{restaurant.address}</span>
                                                    </div>
                                                    {restaurant.landmark && (
                                                        <div className="brand-restaurant-landmark">
                                                            <i className="icon-direction mr-2"></i>
                                                            <span>{restaurant.landmark}</span>
                                                        </div>
                                                    )}
                                                    <div className="brand-restaurant-meta">
                                                        {restaurant.city && (
                                                            <span className="brand-restaurant-meta-item">
                                                                <i className="icon-home"></i>
                                                                {restaurant.city}
                                                            </span>
                                                        )}
                                                        {restaurant.pincode && (
                                                            <span className="brand-restaurant-meta-item">
                                                                <i className="icon-pin"></i>
                                                                {restaurant.pincode}
                                                            </span>
                                                        )}
                                                        {restaurant.distance && (
                                                            <span className="brand-restaurant-meta-item brand-restaurant-distance">
                                                                <i className="icon-map4"></i>
                                                                {parseFloat(restaurant.distance).toFixed(1)} km
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="brand-restaurant-arrow">
                                                    <i className="icon-chevron-right"></i>
                                                </div>
                                                <Ink duration="500" />
                                            </div>
                                        ))
                                    ) : (
                                        <div className="brand-restaurant-empty">
                                            <i className="icon-home"></i>
                                            <p>No locations available</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default withRouter(BrandRestaurantSelector);
